/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { IPaginador } from '@infotrack/presentacion-transversales/interfacesComunes';
import notificacionGlobal from '@infotrack/presentacion-componentes/notificacionGlobal';
import ModeloGestionProducto from 'Infotrack@Modelos/smartStock/gestionProducto';
import IFitrosItem from 'Infotrack@Modelos/smartStock/gestionProducto/entidades/filtrosItem';
import IItem from 'Infotrack@Modelos/smartStock/gestionProducto/entidades/item';
import IItemCompuesto from 'Infotrack@Modelos/smartStock/gestionProducto/entidades/itemCompuesto';
import { manejadorDialogoGlobal } from '@infotrack/presentacion-utilitarios/manejadoresComponentes';

export default class ControladorModeloGestionProducto {
    private modeloGestionProducto: ModeloGestionProducto;
    constructor() {
        this.modeloGestionProducto = new ModeloGestionProducto();
    }

    public consultarListaProductoPrincipal = (paginador: IPaginador, filtros: IFitrosItem) =>
        this.modeloGestionProducto.consultarListaProductoPrincipal({ paginador, items: filtros }).then(({ data }) => ({
            ...data,
            Entidades: data.Entidades.map((entidad) => ({
                ...entidad,
                Ancho: entidad.Ancho * 100,
                Alto: entidad.Alto * 100,
                Largo: entidad.Largo * 100,
            })),
        }));

    public consultarListaItemsCompuestosFiltro = (filtro: IFitrosItem) => {
        return this.modeloGestionProducto.consultarListaItemsPorFiltro(filtro).then(({ data }) => ({
            ...data,
            Entidades: data.Entidades.map((entidad) => ({
                ...entidad,
                Ancho: entidad.Ancho * 100,
                Alto: entidad.Alto * 100,
                Largo: entidad.Largo * 100,
            })),
        }));
    };

    public guardarItemUnidades = async (ItemCompuesto: IItemCompuesto) => {
        await this.modeloGestionProducto.guardarItemUnidades(ItemCompuesto);
    };

    public editarItemUnidades = async (ItemCompuesto: IItemCompuesto) => {
        await this.modeloGestionProducto.editarItemUnidades(ItemCompuesto);
    };

    public async eliminarItem(item: IItem) {
        return this.modeloGestionProducto.eliminarItem(item);
    }

    public validarEntidad(ItemCompuesto: IItemCompuesto): boolean {
        const {
            Abreviatura,
            Alto,
            Ancho,
            DescripcionItem,
            FamiliaId,
            Largo,
            Peso,
            UnidadId,
            Valor,
            ManejaPeso,
            Seriado,
            Serialconsecutivo,
            ClasificacionId,
            MarcaId,
            ReferenciaId,
        } = ItemCompuesto.Item;
        let respuesta = true;

        if (
            Abreviatura === '' ||
            Alto === 0 ||
            Ancho === 0 ||
            DescripcionItem === '' ||
            FamiliaId === 0 ||
            Largo === 0 ||
            Peso === 0 ||
            UnidadId === 0 ||
            ClasificacionId === 0 ||
            ClasificacionId === null ||
            Number.isNaN(Valor!) ||
            Valor === 0 ||
            MarcaId === null ||
            ReferenciaId === null
        ) {
            notificacionGlobal('comunes.alerta.camposIncompletos', 6000, 'warning', true);
            return (respuesta = false);
        }
        if (ManejaPeso && !Seriado && !Serialconsecutivo) {
            notificacionGlobal('gestionproducto.camposSerialManejaPeso', 6000, 'warning', true);
            return (respuesta = false);
        }
        return respuesta;
    }
}
